import { env } from 'next-runtime-env';

export const purchaseProLoader = ({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) => {
  const baseUrl = env('NEXT_PUBLIC_IMAGE_PROXY_URL') || 'https://image-proxy.staging.vwfsds.co.uk';
  const baseImgUrl = baseUrl.replace('api', 'img');
  const height = Math.ceil(width * 0.658);

  const preString = `${baseImgUrl}/unsafe/${width}x${height}/smart/filters:quality(${
    quality || '60'
  }):no_upscale()/`;

  return preString + src;
};

// zero height = resize to width at the source aspect ratio (no crop)
export const purchaseProNativeRatioLoader = ({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) => {
  const baseUrl = env('NEXT_PUBLIC_IMAGE_PROXY_URL') || 'https://image-proxy.staging.vwfsds.co.uk';
  const baseImgUrl = baseUrl.replace('api', 'img');
  return `${baseImgUrl}/unsafe/${width}x0/filters:quality(${quality || '70'}):format(webp):no_upscale()/${src}`;
};
